import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6c3286a2dde7c95f18c01997f26d7d21.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/95 via-primary-800/90 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-3xl">
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            BiviLinks: no vendes, <span className="text-secondary-300">solo conectas</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-4">
            Transforma tus conexiones en ingresos.
          </p>
          
          <p className="text-lg md:text-xl text-gray-300 mb-12">
            Recomienda servicios y gana dinero cada vez que alguien contrata o compra a través de tu enlace.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <Button size="lg" className="shadow-xl hover:shadow-2xl">
              Regístrate como Referidor
            </Button>
            <Button size="lg" variant="outline" className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white/20">
              Soy Proveedor – Quiero clientes
            </Button>
          </div>
          
          <Button size="md" variant="secondary" className="shadow-lg">
            <i className="ri-smartphone-line mr-2"></i>
            Descargar App
          </Button>
          
          <div className="mt-16 pt-8 border-t border-white/20">
            <p className="text-2xl md:text-3xl font-semibold text-white">
              Cada conexión cuenta. <span className="text-secondary-300">Cada conexión paga.</span>
            </p>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/50"></i>
      </div>
    </section>
  );
};
